import { Badge, Breadcrumb, Button, Calendar, Checkbox, Col, DatePicker, Divider, Drawer, Dropdown, Flex, Form, Input, InputNumber, Layout, Radio, Row, Select, Space, Table, Tag, TimePicker, theme } from 'antd';
import {
    SendOutlined,
    MoreOutlined,
    MessageOutlined,
    UnlockOutlined,
    EyeOutlined,
    LockOutlined,
    EditOutlined
} from '@ant-design/icons';
import React, { useRef, useState } from 'react'
import TextArea from 'antd/es/input/TextArea';

const { Search } = Input;
const { Header, Sider, Content } = Layout;


const options = [
    {
        label: 'Approve',
        value: 'approve',
    },
    {
        label: 'Reject',
        value: 'reject',
    },
    {
        label: 'Abstain',
        value: 'abstain',
    },
];
export default function MyVote() {

    const {
        token: { colorBgContainer, borderRadiusLG },
    } = theme.useToken();

    const [value, setValue] = useState('Never');
    const [showTextArea, setShowTextArea] = useState(false);

    const onChange = ({ target: { value } }) => {
        console.log('radio checked', value);
        setValue(value);
    };

    const onChangeSignatory = (e) => {
        setShowTextArea(e.target.checked)
    };

    return (
        <>
            <Form>
                <Form.Item>
                    <Radio.Group options={options} onChange={onChange} value={value} optionType="button" />
                </Form.Item>
            </Form>

        </>
    )
}